import React, {
  forwardRef,
  useCallback,
  useRef,
  useImperativeHandle,
} from "react";
import Table from "../../../shared/Table";
import { COLUMN_DEFINITIONS, PAGE_SIZE_OPTIONS } from "./table.config";
import TableLayout from "../../../layouts/TableLayout/NewTableLayout";

const LegsTable = forwardRef(
  (
    {
      data,
      setData,
      loading,
      pagination,
      onPaginationChange,
      fullTextSearch,
      globalSearchFilters = ["orderNumber", "appointmentDate"],
      ...rest
    },
    ref
  ) => {
    const tableRef = useRef(null);
    const tableData = React.useMemo(() => data, [data]);

    // Expose methods to parent component
    useImperativeHandle(
      ref,
      () => ({
        resetSelectedRows: (value) => {
          // console.log("🔄 LegsTable resetSelectedRows called with:", value);
          // console.log("🔧 tableRef.current exists:", !!tableRef.current);
          // console.log(
          //   "🔧 tableRef.current.resetSelectedRows exists:",
          //   !!tableRef.current?.resetSelectedRows
          // );

          // Reset the internal selection state
          if (tableRef.current && tableRef.current.resetSelectedRows) {
            // console.log("📋 Calling table resetSelectedRows...");
            tableRef.current.resetSelectedRows(value);

            // Try a second call to make sure it takes effect
            setTimeout(() => {
              // console.log("📋 Second call to resetSelectedRows...");
              tableRef.current.resetSelectedRows(false);
            }, 100);
          }
          // Also clear the parent state
          // console.log("🧹 Clearing parent selection state...");
          setData([]);
        },
      }),
      [setData]
    );

    const handleRowSelection = useCallback(
      (value) => {
        setData(value);
      },
      [setData]
    );

    return (
      <>
        <TableLayout
          hideActions
          hideMainAction
          ref={tableRef}
          search
          loading={loading}
          title="Legs"
          columns={COLUMN_DEFINITIONS}
          data={tableData}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
          sendSelectedItems={handleRowSelection}
          pagination={pagination}
          onPaginationChange={onPaginationChange}
          globalSearchFilters={globalSearchFilters}
          fullTextSearch={fullTextSearch}
          {...rest}
        />
      </>
    );
  }
);

export default LegsTable;
